import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (
  environment.mode == 'PROD' ||
  environment.mode == 'PRE' ||
  environment.mode == 'GCP_PROD'
) {
  enableProdMode();
  if (window) {
    //window.console.log = function () {};
    window.console.table = function () {};
  }
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
